// extracted by mini-css-extract-plugin
export var copy = "styles-module--copy--eXPqM";
export var doctors = "styles-module--doctors--x9unc";
export var pictures = "styles-module--pictures--OHpke";